import Vue from 'vue'

class PdlRepository {
    get(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/get/' + id,
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    search(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/search',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    create(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/create',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/update/' + id,
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/delete/' + id,
                method: 'delete',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    locations(pdlId) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/locations',
                method: 'post',
                data: {pdlId},
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    assignToLocation(locationId, pdlId) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl/assign-to-location',
                method: 'post',
                data: {locationId, pdlId},
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    searchEnergyPrices(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl-energy-price/search',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    createEnergyPrice(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl-energy-price/create',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    updateEnergyPrice(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl-energy-price/update/' + id,
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    deleteEnergyPrice(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/pdl-energy-price/delete/' + id,
                method: 'delete',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new PdlRepository()
